require('core-js/es6');
module.exports = require('core-js/modules/$').core;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-es6-polyfill/es6-shim.js
 ** module id = 527
 ** module chunks = 0
 **/